import { COURSE_SYSTEM_PROMPT } from "./aiPrompts";

/**
 * Factory: returns an AI config for a specific course number (1–8).
 * Each course has its own namespace (course1Title, course1FinalPercentageMark, etc.)
 */
export const COURSE_CONFIG = (courseNum) => ({
  systemPrompt: COURSE_SYSTEM_PROMPT,
  getStudentReportInfo: (v) => {
    const p = `course${courseNum}`;
    return {
      courseTitle: v[`${p}Title`],
      courseCode: v[`${p}Code`],
      firstPercentageMark: v[`${p}FirstPercentageMark`],
      finalPercentageMark: v[`${p}FinalPercentageMark`],
      classesMissed: v[`${p}FinalClassesMissed`],
      timesLate: v[`${p}FinalTimesLate`],
      responsibility: v[`${p}FinalResponsibility`],
      organization: v[`${p}FinalOrganization`],
      independentWork: v[`${p}FinalIndependentWork`],
      collaboration: v[`${p}FinalCollaboration`],
      initiative: v[`${p}FinalInitiative`],
    };
  },
});
